var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup162732(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.788,
    height: 41.756,
    viewBox: "0 0 49.788 41.756",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_162732",
    "data-name": "Group 162732",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5424",
    "data-name": "Path 5424",
    d: "M855.45,517.254l.227-.145.067-.043a2.22,2.22,0,0,1-.227-4.327l-.011.915.5-1h0a2.221,2.221,0,0,1,2.323,2.116v.126a2.659,2.659,0,0,0,.438-.647,3.806,3.806,0,0,0,.2-1.667c-.034-1.295-.09-2.6-.163-3.9a2.219,2.219,0,0,1-1.972-2.1,1.97,1.97,0,0,1,0-.2v-.05a1.206,1.206,0,0,1,.021-.192c0-.01,0-.02,0-.031.008-.053.019-.105.031-.158a.282.282,0,0,1,.015-.058c.016-.057.033-.113.053-.168.007-.018.013-.035.021-.053.016-.041.033-.081.051-.12.009-.021.018-.042.029-.062l.008-.016h0a2.223,2.223,0,0,1,2.612-1.127l-.015,1.191.5-.983a2.218,2.218,0,0,1,1.108,1.817,2.186,2.186,0,0,1-.049.573h0a.248.248,0,0,1-.012.047c0,.016-.015.059-.023.088s-.022.074-.034.114-.018.055-.028.082-.033.077-.05.114-.019.044-.03.067c-.028.057-.059.114-.092.168-.011.019-.025.037-.036.056l-.074.114a.43.43,0,0,1-.05.064c-.017.021-.049.061-.075.091s-.038.041-.057.061-.054.057-.084.084l-.058.055-.1.084-.052.041c-.053.039-.107.075-.163.114l-.032.018c-.047.029-.095.055-.144.078l-.064.028c-.04.018-.081.036-.123.051l-.073.026c-.041.015-.082.027-.124.039l-.075.019c-.045.011-.092.02-.139.028h-.009q.045.824.082,1.648a2.219,2.219,0,0,1,3.082-.964l-.392,1.077.807-.776a2.214,2.214,0,0,1,.718,1.533,2.187,2.187,0,0,1-.057.612,2.22,2.22,0,0,1-4.088.605v.167a4.378,4.378,0,0,1-.254,1.931,3.923,3.923,0,0,1-.818,1.1c-.2.205-.411.4-.625.6a2.233,2.233,0,0,1-.8.667q-.528.406-1.093.762l-.2.143c-.211.132-.428.266-.641.405l.114-.009a2.221,2.221,0,0,1,2.186,1.446l-1.388,1.136,1.527-.354a2.225,2.225,0,0,1-3.18,2c.035.042.069.085.1.128l.2.252c.908,1.145,1.155,2.23.708,3.058l-.544-.294c.435-.806-.219-1.837-.648-2.385-.065-.083-.132-.166-.2-.249a4.118,4.118,0,0,1-1.215-2.527C852.819,518.884,854.278,517.98,855.45,517.254Z",
    transform: "translate(-822.788 -496.276)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5425",
    "data-name": "Path 5425",
    d: "M682.7,453.455l-.349-.218c-.034-.02-.067-.042-.1-.063a3.326,3.326,0,0,0,.341-6.48l.017,1.371-.753-1.491h-.009a3.326,3.326,0,0,0-3.477,3.168v.188a3.971,3.971,0,0,1-.658-.971,5.69,5.69,0,0,1-.3-2.5c.05-1.94.134-3.894.243-5.842a3.324,3.324,0,0,0,2.953-3.147v-.377c-.007-.1-.016-.192-.031-.286a.1.1,0,0,0-.008-.047c-.014-.079-.031-.158-.05-.236-.007-.03-.014-.058-.021-.088-.024-.085-.049-.168-.079-.251-.009-.027-.021-.053-.032-.081-.024-.061-.049-.12-.076-.179-.015-.032-.028-.062-.043-.093a.236.236,0,0,1-.011-.024h0a3.324,3.324,0,0,0-2.811-1.817,3.362,3.362,0,0,0-1.095.132l.022,1.784-.744-1.476a3.306,3.306,0,0,0-1.59,3.584h0a.334.334,0,0,0,.018.069c.01.044.022.088.033.131s.034.114.052.165.027.082.043.121c.022.059.048.114.074.174.015.034.029.068.044.1.042.085.088.169.137.251.017.03.036.057.055.084a1.65,1.65,0,0,0,.114.164c.024.033.05.064.075.1s.074.092.113.136l.084.092q.061.065.126.126l.087.081c.049.043.1.085.152.125.026.02.051.042.078.063.078.058.159.114.243.163.016.01.033.018.049.027.071.041.142.081.215.114l.1.043c.06.027.12.053.183.076.036.015.073.027.113.04.061.021.124.04.186.057l.114.029c.069.016.139.03.208.042h.014q-.07,1.234-.123,2.467A3.324,3.324,0,0,0,672,441.61l.588,1.61-1.209-1.161a3.309,3.309,0,0,0-1.074,2.3,3.265,3.265,0,0,0,.084.917,3.324,3.324,0,0,0,6.115.908c0,.084,0,.168-.008.251a6.607,6.607,0,0,0,.38,2.9,5.835,5.835,0,0,0,1.225,1.651q.454.463.936.895a3.327,3.327,0,0,0,1.2,1q.795.608,1.637,1.136l.352.218c.316.2.641.4.958.608-.056,0-.114-.011-.168-.014a3.325,3.325,0,0,0-3.274,2.164l2.077,1.691-2.286-.529a3.33,3.33,0,0,0,4.77,3c-.052.063-.1.127-.154.192-.1.127-.2.253-.3.378-1.352,1.714-1.728,3.339-1.06,4.579l.816-.439c-.652-1.207.328-2.752.971-3.565.1-.124.2-.247.3-.372.864-1.073,1.843-2.291,1.817-3.783C686.636,455.9,684.452,454.546,682.7,453.455Z",
    transform: "translate(-661.01 -433.99)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5426",
    "data-name": "Path 5426",
    d: "M593.3,697.863a33.43,33.43,0,0,0-4.671-.964c-.74.076,1.123-3.559,2.364-3.116s2.9,1.61,3.844-.037,1.476-2.535,2.631-2.446,2.749-.71,3.9,0,1.961,1.583,3.553,1.546,3.1-3.585,4.34-2.167,2.725,2.719,3.891,2.246,2.5.237,3.56,1.036a3.334,3.334,0,0,0,3.634-.177,3.159,3.159,0,0,1,2.751-.975c1.508.089,6.3,1.153,8.071,2.484s-2.307,3.015-4.258,3.015-2.306.533-3.992,1.331-4.435-.444-6.385.887-4.435-.71-7.805,0-2.661,1.685-4.613.976-1.241-.976-4.079-1.153-5.943.443-6.209-.71-2.044-1.419-3.1-1.774S593.3,697.863,593.3,697.863Z",
    transform: "translate(-588.465 -661.232)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5427",
    "data-name": "Path 5427",
    d: "M513,506.993l-1.522,4.664-.066.2-2.547,7.808-4.361,2.947-21.176-8.9,2.007-8.115.107-.427,1.074-4.344,0-.01,6.518-.815Z",
    transform: "translate(-475.611 -482.624)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5428",
    "data-name": "Path 5428",
    d: "M537.884,506.993l-4.135,12.676-4.361,2.947,4-13.833L511.4,500.826l0-.01,6.519-.815Z",
    transform: "translate(-500.493 -482.624)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5429",
    "data-name": "Path 5429",
    d: "M550.5,510.383l-.351-.214,3.518-.369,15.072,5.328-.425.223-14.869-5.243Z",
    transform: "translate(-534.843 -491.311)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5430",
    "data-name": "Path 5430",
    d: "M527.143,552.008l-4.4,2.07-21.635-8.558-.107.427,21.654,8.435,4.423-2.171",
    transform: "translate(-491.274 -522.975)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_697",
    "data-name": "Ellipse 697",
    cx: 0.757,
    cy: 0.818,
    rx: 0.757,
    ry: 0.818,
    transform: "translate(10.659 21.504) rotate(-72.75)",
    fill: "#6f6f6f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_698",
    "data-name": "Ellipse 698",
    cx: 0.757,
    cy: 0.818,
    rx: 0.757,
    ry: 0.818,
    transform: "translate(29.727 28.887) rotate(-72.75)",
    fill: "#6f6f6f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_699",
    "data-name": "Ellipse 699",
    cx: 0.757,
    cy: 0.818,
    rx: 0.757,
    ry: 0.818,
    transform: "translate(26.714 38.056) rotate(-72.75)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_700",
    "data-name": "Ellipse 700",
    cx: 0.757,
    cy: 0.818,
    rx: 0.757,
    ry: 0.818,
    transform: "translate(8.326 30.363) rotate(-72.75)",
    fill: "#6f6f6f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5431",
    "data-name": "Path 5431",
    d: "M694.292,592.454c-.045.148-.41,0-.873-.145s-.824-.3-.779-.454.482-.227.945-.083S694.339,592.306,694.292,592.454Z",
    transform: "translate(-680.806 -573.786)",
    fill: "#6f6f6f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_701",
    "data-name": "Ellipse 701",
    cx: 0.279,
    cy: 0.797,
    rx: 0.279,
    ry: 0.797,
    transform: "translate(14.213 17.93) rotate(-72.75)",
    fill: "#6f6f6f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5432",
    "data-name": "Path 5432",
    d: "M780.411,624.331c-.045.148-.5.011-.943-.126s-.786-.291-.74-.438.464-.227.909-.094S780.459,624.181,780.411,624.331Z",
    transform: "translate(-757.118 -602.071)",
    fill: "#6f6f6f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5433",
    "data-name": "Path 5433",
    d: "M862.559,653.6c-.051.166-.535.022-1-.124s-.833-.312-.782-.478.5-.267.969-.121S862.611,653.431,862.559,653.6Z",
    transform: "translate(-829.845 -627.955)",
    fill: "#6f6f6f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5434",
    "data-name": "Path 5434",
    d: "M886.817,650.1c-.052.166-.535.022-1-.124s-.835-.312-.782-.478.5-.267.969-.122S886.869,649.931,886.817,650.1Z",
    transform: "translate(-851.348 -624.853)",
    fill: "#6f6f6f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5435",
    "data-name": "Path 5435",
    d: "M901.225,643.535c-.052.166-.454.048-.838-.073s-.681-.266-.635-.432.434-.288.821-.168S901.276,643.369,901.225,643.535Z",
    transform: "translate(-864.398 -619.1)",
    fill: "#6f6f6f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5436",
    "data-name": "Path 5436",
    d: "M820.813,614.83c-.041.132-.454.01-.847-.114s-.708-.262-.665-.394.417-.208.814-.085S820.853,614.7,820.813,614.83Z",
    transform: "translate(-793.083 -593.713)",
    fill: "#6f6f6f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_702",
    "data-name": "Ellipse 702",
    cx: 0.279,
    cy: 0.688,
    rx: 0.279,
    ry: 0.688,
    transform: "translate(17.491 17.862) rotate(-72.75)",
    fill: "#6f6f6f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5437",
    "data-name": "Path 5437",
    d: "M754.851,646.333a.718.718,0,0,0-.329-.836.731.731,0,0,0,.149-.265,3.588,3.588,0,0,1-1.21-1.769,1.873,1.873,0,0,1-1.548.156.718.718,0,0,0-.458.468.2.2,0,0,1-.011.046l-.025.012a.718.718,0,1,0-.694,1.219.634.634,0,0,0,.113.025l.009.263,3.436,1.4-.023-.227A.72.72,0,0,0,754.851,646.333Z",
    transform: "translate(-731.851 -619.616)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5438",
    "data-name": "Path 5438",
    d: "M747.327,671.2a.719.719,0,0,1-.818.374.7.7,0,0,1-.076.293.718.718,0,0,1-.964.319.733.733,0,0,1-.265-.227.718.718,0,0,1-1.34-.464.732.732,0,0,1-.227-.07.718.718,0,0,1-.319-.963l.023-.042-.009-.026a.713.713,0,0,1-.3-.076.721.721,0,0,1,.652-1.287.776.776,0,0,1,.1.058l.188-.183,3.457,1.382-.174.148A.718.718,0,0,1,747.327,671.2Z",
    transform: "translate(-725.13 -642.223)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5439",
    "data-name": "Path 5439",
    d: "M758.548,651.223l-.835,2.7a.813.813,0,0,0,.492,1h0a.812.812,0,0,0,1.058-.52l.835-2.706a.811.811,0,0,0-.577-1.022h0A.811.811,0,0,0,758.548,651.223Z",
    transform: "translate(-738.46 -626.052)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5440",
    "data-name": "Path 5440",
    d: "M759.5,653.091l-.757,2.426a.727.727,0,0,0,.442.9h0a.728.728,0,0,0,.948-.467l.753-2.427a.729.729,0,0,0-.518-.922h0A.729.729,0,0,0,759.5,653.091Z",
    transform: "translate(-739.375 -627.755)",
    fill: "#6f6f6f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5441",
    "data-name": "Path 5441",
    d: "M640.944,708.8a33.291,33.291,0,0,0-4.671-.963c-.741.077,1.123-3.56,2.364-3.116s2.9,1.609,3.844-.039,1.476-2.534,2.631-2.445,2.749-.71,3.9,0,1.961,1.582,3.553,1.545,3.1-3.585,4.341-2.166,2.725,2.718,3.891,2.246,2.5.237,3.559,1.036a3.337,3.337,0,0,0,3.634-.177,3.159,3.159,0,0,1,2.749-.977c1.508.089,6.3,1.154,8.071,2.484s-2.305,3.016-4.258,3.016-2.305.531-3.99,1.33-4.436-.443-6.387.887-4.435-.708-7.805,0-2.661,1.685-4.612.977-1.242-.977-4.08-1.154-5.943.444-6.208-.71-2.038-1.418-3.1-1.774S640.944,708.8,640.944,708.8Z",
    transform: "translate(-630.695 -670.926)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5442",
    "data-name": "Path 5442",
    d: "M961.142,633.618a1.882,1.882,0,0,0-.486-1.951,3.156,3.156,0,0,1-.967-1.85c.017-1.022,1.1-1.625,1.968-2.168a9.536,9.536,0,0,0,1.767-1.421,2.569,2.569,0,0,0,.543-.727,2.953,2.953,0,0,0,.164-1.291q-.056-2.187-.217-4.371",
    transform: "translate(-917.532 -598.734)",
    fill: "none",
    stroke: "#f1f1f1",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5443",
    "data-name": "Path 5443",
    d: "M986.6,607.276a1.59,1.59,0,0,0-.8-1.306l-.356.706.011-.855a1.612,1.612,0,0,0-.526-.064,1.59,1.59,0,1,0,1.667,1.518Z",
    transform: "translate(-938.571 -586.25)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5444",
    "data-name": "Path 5444",
    d: "M962.931,696.029a1.59,1.59,0,1,1,.077-1.283l-1,.814,1.1-.253A1.594,1.594,0,0,1,962.931,696.029Z",
    transform: "translate(-917.744 -664.216)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5445",
    "data-name": "Path 5445",
    d: "M966.166,662.008a1.59,1.59,0,0,1-.5-3.126l-.008.656.36-.714h0a1.59,1.59,0,0,1,1.669,1.517,1.571,1.571,0,0,1-.068.544A1.59,1.59,0,0,1,966.166,662.008Z",
    transform: "translate(-921.766 -633.289)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5446",
    "data-name": "Path 5446",
    d: "M1000.644,639.4a1.59,1.59,0,1,1,.705-2.983l-.282.772.579-.556a1.589,1.589,0,0,1,.514,1.1,1.548,1.548,0,0,1-.04.439A1.59,1.59,0,0,1,1000.644,639.4Z",
    transform: "translate(-952.375 -613.254)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5447",
    "data-name": "Path 5447",
    d: "M986.444,614.512c-.368.04-.726.154-1.095.177a1.185,1.185,0,0,1-1.007-.352,4.7,4.7,0,0,1-.3-.519,1.135,1.135,0,0,0-.4-.378,1.59,1.59,0,1,0,2.98,1.058Q986.535,614.5,986.444,614.512Z",
    transform: "translate(-938.63 -593.061)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5448",
    "data-name": "Path 5448",
    d: "M1000.5,646.481a1.6,1.6,0,0,1-1.516-2.271,1.176,1.176,0,0,1,.322.317,5.006,5.006,0,0,0,.317.527,1.3,1.3,0,0,0,1.056.37c.385-.017.756-.127,1.136-.162.053,0,.114-.008.161-.009a1.59,1.59,0,0,1-1.476,1.229Z",
    transform: "translate(-952.229 -620.337)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5449",
    "data-name": "Path 5449",
    d: "M966.42,669.364a1.59,1.59,0,0,1-1.526-2.244,1.287,1.287,0,0,1,.341.324c.124.175.2.377.341.538a1.48,1.48,0,0,0,1.129.4c.408-.009.774-.105,1.167-.136A1.591,1.591,0,0,1,966.42,669.364Z",
    transform: "translate(-922.021 -640.646)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5450",
    "data-name": "Path 5450",
    d: "M962.608,703.98a4.494,4.494,0,1,0-2.556-.988,6.907,6.907,0,0,0,.427.568,1.984,1.984,0,0,0,1.321.465A6.805,6.805,0,0,0,962.608,703.98Z",
    transform: "translate(-917.421 -672.167)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5451",
    "data-name": "Path 5451",
    d: "M951.32,729.515a4.61,4.61,0,0,0,1.637-.309c.379-.27,1.931-.592,2.03-.159s1.89,2.157.47,2.164a12.045,12.045,0,0,1-3.678-.454C951.4,730.524,951.32,729.515,951.32,729.515Z",
    transform: "translate(-910.114 -695.353)",
    fill: "#6f6f6f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5452",
    "data-name": "Path 5452",
    d: "M955.512,736.34a12.108,12.108,0,0,1-3.678-.454c-.288-.176-.4-.805-.442-1.1h-.042s.079,1.015.454,1.249a11.992,11.992,0,0,0,3.678.454c.41,0,.551-.149.544-.365C955.966,736.256,955.814,736.337,955.512,736.34Z",
    transform: "translate(-910.14 -700.631)",
    opacity: 0.2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup162732);
export default __webpack_public_path__ + "static/media/Group-162732.f7d55b8fcfd4ba08e40d2f9be245e0ca.svg";
export { ForwardRef as ReactComponent };